import { usePortalStore } from 'domains/portal/PortalStore';
import { UserPortalSettingInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Portal';

export function setPortalSetup(setup: UserPortalSettingInfo) {
  // also push to portal store, until we get rid of this bare module...
  usePortalStore.getState().actions.setPortalSettingInfo(setup);
}

export function getPortalSetup() {
  return usePortalStore.getState().portalSettings;
}
